<template>
  <v-row>
    <v-col>
      <div
        class="wrapper"
      >
        <v-menu
          offset-y
          :close-on-content-click="false"
          top
          content-class="checkbox-menu"
        >
          <template #activator="{ on, attrs }">
            <div
              v-bind="attrs"
              style="width: 100%;"
              v-on="on"
            >
              <universal-button
                type="base"
                :label="menuTitle"
                class="dropdown-button"
                :append-icon="attrs['aria-expanded'] === 'true' ? 'mdi-chevron-up' : 'mdi-chevron-down'"
              />
            </div>
          </template>
          <v-col
            v-for="item in items"
            :key="item.id"
          >
            <checkbox-field
              v-model="item.value"
              :config="{
                label: item.text
              }"
              @change="val => $emit('change', {
                item,
                val
              })"
            />
          </v-col>
        </v-menu>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import UniversalButton from '../buttons/UniversalButton.vue'
import CheckboxField from '@/global/components/fields/CheckboxField.vue'

export default {
  name: 'CheckboxListMenu',

  components: {
    CheckboxField,
    UniversalButton
  },

  props: {
    menuTitle: {
      type: String,
      default: 'Dropdown'
    },

    items: {
      type: Array,
      default: () => ([])
    }
  }
}
</script>

<style scoped lang="scss">
.dropdown-button {
  width: 100%;
  height: 40px !important;
  color: #6B7280;
}

.checkbox-menu {
  background-color: #FFFFFF;
}

::v-deep {
  .dropdown-button > .v-btn__content {
    position: relative;
  }
  .dropdown-button > .v-btn__content > span {
    position: absolute;
    left: 0;
  }
  .dropdown-button > .v-btn__content > i {
    position: absolute;
    right: 0;
  }
}

@media (max-width: 600px) {
  .wrapper {
    border-bottom: 1px solid #E5E7EB;
    padding-bottom: 16px;
  }
}
</style>
